import { cadenzaUrl } from '@disy/lib.backend/cadenza-url';
import { openUrl } from '@disy/lib/open-url';

import type { WorkbookId } from 'cadenza/repository/model/workbook-id.gen';
import type { TestSuiteMode } from 'cadenza/testsuite/testsuite/testsuite';
import type { WorkbookVersion } from 'cadenza/workbook/api/workbook-version';

/**
 * Opens workbook test suite page with validation results for this workbook (if it was already validated) or starts validating it.
 */
export function openWorkbookTestSuite(
  { repositoryName, itemName }: WorkbookId,
  {
    version,
    testSuiteResultId,
    mode = testSuiteResultId ? 'SHOW_WORKBOOK' : 'VALIDATE_WORKBOOK',
  }: {
    version?: WorkbookVersion;
    testSuiteResultId?: string;
    mode?: Extract<TestSuiteMode, 'SHOW_WORKBOOK' | 'SHOW_WORKBOOK_NETWORK' | 'VALIDATE_WORKBOOK'>;
  } = {},
) {
  const params = new URLSearchParams(testSuiteResultId ? { mode, testSuiteResultId } : { mode: 'VALIDATE_WORKBOOK' });
  openUrl(
    cadenzaUrl(
      `/repositories/${repositoryName}/workbooks/${itemName}` +
        (version ? `/versions/${version}/tests?${params}` : `/tests?${params}`),
    ),
  );
}
